// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"066f398b","707":"381f8b96","729":"16feb460"}[chunkId] + ".js";
};